import { render, staticRenderFns } from "./PrintOfficialsTable.vue?vue&type=template&id=54fb1890&"
import script from "./PrintOfficialsTable.vue?vue&type=script&lang=js&"
export * from "./PrintOfficialsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports